import {
  Bot,
  Bell,
  CreditCard,
  FileCode,
  Link2,
  Palette,
  Settings,
  Store,
  Users,
} from "lucide-react";
import { integrationsHref } from "@/lib/integrations-href";
import type { NavMainItem } from "./nav-types";

export const settingsSideBarData: NavMainItem[] = [
  {
    title: "Account",
    url: "/settings",
    icon: Settings,
  },
  {
    title: "Members",
    url: "/settings/members",
    icon: Users,
    permissions: { sensitiveData: ["read"] },
  },
  {
    title: "Billing",
    url: "/settings/billing",
    icon: CreditCard,
    permissions: { sensitiveData: ["read"], billing: ["read"] },
  },
  {
    title: "Brand",
    url: "/settings/brand",
    icon: Palette,
  },
  {
    title: "Integrations",
    url: integrationsHref(),
    icon: Link2,
    permissions: { sensitiveData: ["read"] },
  },
  {
    title: "Notifications",
    url: "/settings/notifications",
    icon: Bell,
    permissions: { messaging: ["read"] },
    entitlement: "slack",
  },
  {
    title: "Storefront Settings",
    url: "/settings/storefront",
    icon: Store,
  },
  {
    title: "AI Knowledge",
    url: "/settings/agent",
    icon: Bot,
    permissions: { aiChat: ["read"] },
  },
  {
    title: "Custom Scripts",
    url: "/settings/custom-scripts",
    icon: FileCode,
    permissions: { sensitiveData: ["read"] },
  },
];
